export interface IUser {
  id: number;
  email: string;
  name: string;
  isAdmin: boolean;
  hasLister: boolean;
  hasWidget: boolean;
  isRoot: boolean;
  isSeminargo: boolean;
  isSingleSpace: boolean;
  isSingleAdminSpace: boolean;
  space: ISpace | null;
  memberships: IUserMembership[];
  spaces: ISpace[];
  hotels: IHotel[];
}

export interface IUserMembership {
  isAdmin: boolean;
  space?: ISpace | null | undefined;
}

export interface ISpace {
  id: number;
  name: string;
  country: string;
  hasEpilo?: boolean;
  activeSEMPlan?: { id: number; semPlan: { id: number; plan: string; label: string } } | null;
  parent?: ISpace | null | undefined;
  children?: ISpace[] | null | undefined;
}

export interface IBoundToSpace {
  space?: ISpace | null | undefined;
}

export interface IHotel {
  id: number;
  name: string;
  extRefCode?: string | null;
  space: ISpace;
}

/**
 * Filter state for hotel selection in the UI.
 * Includes optional display names for users who don't load all spaces/hotels.
 */
export interface IHotelFilter {
  spaceId: number | null;
  hotelId: number | null;
  // Optional names for display (used by Seminargo users who don't load all spaces/hotels)
  spaceName?: string | null;
  hotelName?: string | null;
  // Space ID of the hotel (used for loading space data on page reload when only hotelId is set)
  hotelSpaceId?: number | null;
}

export enum EPriceDisplayMode {
  NET = 'net',
  GROSS = 'gross',
}

export enum EBookingMode {
  EPILO = 'epilo',
  SEM = 'sem',
}
